import api from '../backAxios';

class TvService {
    async buscarTodaTVs() {
        try {
            const envioLink = await api.get(
                'tv-telas/tvs'                
            );

            return envioLink;
        } catch (error) {
            throw new Error(error);
        }
    }

    async criaTV(body) {
        try {
            const envioLink = await api.post(
                'tv-telas/tvs',
                body                
            );

            return envioLink;
        } catch (error) {
            throw new Error(error);
        }
    }

    async atualizaTV(body, id) {
        try {
            const envioLink = await api.put(
                `tv-telas/tvs/${id}`,
                body                
            );

            return envioLink;
        } catch (error) {
            throw new Error(error);
        }
    }

    async deleteTV(id) {
        try {
            const envioLink = await api.delete(
                `tv-telas/tvs/${id}`                                
            );

            return envioLink;
        } catch (error) {
            throw new Error(error);
        }
    }

    async vincularTvGrupo(id, body) {
        try {
            const envioLink = await api.put(
                `tv-telas/tvs/atualizaTvGrupo/${id}?operacao=vincular`,
                body                
            );

            return envioLink;
        } catch (error) {
            throw new Error(error);
        }
    }

    async desvincularTvGrupo(id, body) {
        try {
            const envioLink = await api.put(
                `tv-telas/tvs/atualizaTvGrupo/${id}?operacao=desvincular`,
                body                
            );

            return envioLink;
        } catch (error) {
            throw new Error(error);
        }
    }      
}

export default new TvService();
